export enum TemplateType {
  Undefined = 0,
  Accounts = 1,
  Locations = 2,
  Users = 3,
  Products = 4
}
